import "./DetailsPageUpperLayer.css";
import { Link, Typography, Tooltip } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const DetailsPageUpperLayer = ({
  hName,
  tabName,
  hProps,
  fieldLabels = {},
}) => {
  const navigate = useNavigate();

  const theme = createTheme({
    typography: {
      allVariants: {
        fontSize: 12,
        fontWeight: "bolder",
      },
    },
  });

  const handleClick = (path, value) => {
    navigate(path + value);
  };

  // const checkOverflow = (item) => {
  //   const s = typeof item === "string" ? item : String(item ?? "");
  //   return tabName === "Track & Trace" ? s.length > 26 : s.length > 22;
  // };

  const checkOverflow = (item) => {
    const s = typeof item === "string" ? item : String(item ?? "");
    // Decide max width based on tabName
    const maxWidth = tabName === "Track & Trace" ? 180 : 150; // px value depending on your design
    return measureTextWidth(s, maxWidth);
  };

  const measureTextWidth = (text, containerWidth) => {
    const span = document.createElement("span");
    span.style.visibility = "hidden";
    span.style.whiteSpace = "nowrap";
    span.style.fontSize = "12px";
    span.style.fontWeight = "bolder";
    span.style.fontFamily = "Arial, sans-serif";
    span.innerText = text;

    document.body.appendChild(span);
    const textWidth = span.offsetWidth;
    document.body.removeChild(span);

    return textWidth > containerWidth;
  };

  const checkHeaderValues = (item) =>
    item === "shipmentNo" ||
    item === "deliveryNo" ||
    item === "orderNo" ||
    item === "item";

  const convertCamelToTitleCase = (str) =>
    str
      .replace(/([A-Z])/g, " $1")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

  // Normalize values so empty string / arrays / objects also become "TBD"
  // const normalizeValue = (key, v) => {
  //   if (key === "incoterm" && (v === null || v === undefined || (typeof v === "string" && v.trim() === ""))) {
  //     return ""; // show nothing instead of "TBD"
  //   }
  //   if (v === null || v === undefined) return "TBD";
  //   if (typeof v === "string") return v.trim() === "" ? "TBD" : v;
  //   if (Array.isArray(v)) return v.length ? v.join(", ") : "TBD";
  //   if (typeof v === "object") return "TBD";
  //   return v;
  // };

  return (
    <div className="container" align="left">
      {Object.entries(hProps).map(([key, value]) => {
        if (
          key === "line" ||
          key === "deliveryLines" ||
          key === "deliveryOutboundShipmentLine" ||
          key === "exceptionType" ||
          key === "fkLink"
        ) {
          return null;
        }

        // const isReactElement = (value) => typeof value === "object" && value !== null && "$$typeof" in value;
        // const displayValue = isReactElement(value) ? value : normalizeValue(key, value);
        const showAsLink =
          key === "shipmentNo" &&
          value !== "TBD" &&
          (hName === "Inbound Deliveries Detail" ||
            hName === "Outbound Deliveries Detail");
        const label = fieldLabels[key] || convertCamelToTitleCase(key);

        return (
          <div
            key={key}
            className={
              tabName === "Track & Trace"
                ? "trackItem"
                : key === "stock"
                ? "stockItem"
                : "item"
            }
          >
            <ThemeProvider theme={theme}>
              {checkOverflow(label) ? (
                <Tooltip title={label} placement="top" arrow>
                  <Typography className="itemText" sx={{ color: "#3e3e3eff" }}>
                    {label}
                  </Typography>
                </Tooltip>
              ) : (
                <Typography className="itemText" sx={{ color: "#3e3e3eff" }}>
                  {label}
                </Typography>
              )}

              {showAsLink ? (
                hName === "Inbound Deliveries Detail" ? (
                  <Link
                    underline="always"
                    color="primary"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      handleClick(
                        "/core/supply/shipment/shipment-detail/",
                        value,
                        "Inbound Shipments",
                        "Inbound Shipments Detail"
                      )
                    }
                  >
                    <Typography>{value}</Typography>
                  </Link>
                ) : (
                  <Link
                    underline="always"
                    color="primary"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      handleClick(
                        "/core/demand/shipment/shipment-detail/",
                        value,
                        "Outbound Shipments",
                        "Outbound Shipments Detail"
                      )
                    }
                  >
                    <Typography>{value}</Typography>
                  </Link>
                )
              ) : checkOverflow(value) ? (
                <Tooltip title={value} placement="bottom" arrow>
                  <Typography
                    className="itemText"
                    fontWeight={checkHeaderValues(key) ? "bolder" : "medium"}
                    sx={{
                      color: checkHeaderValues(key) ? "#000000" : "#292929ff",
                    }}
                  >
                    {value}
                  </Typography>
                </Tooltip>
              ) : (
                <Typography
                  className="itemText"
                  fontWeight={checkHeaderValues(key) ? "bolder" : "medium"}
                  sx={{
                    color: checkHeaderValues(key) ? "#000000" : "#292929ff",
                    fontStyle: "normal",
                    opacity: 1,
                  }}
                >
                  {value}
                </Typography>
              )}
            </ThemeProvider>
          </div>
        );
      })}
    </div>
  );
};

export default DetailsPageUpperLayer;
